import React from "react";

export default function Pattern1({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="172"
      height="71"
      viewBox="0 0 172 71"
      className={className}
    >
      <defs>
        <rect id="pattern1rect" width="172" height="71" x="0" y="0" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="matrix(-1 0 0 1 172 0)">
        <mask id="pattern1mask" fill="#fff">
          <use xlinkHref="#pattern1rect" />
        </mask>
        <path
          fill="currentColor"
          d="M-630.801015,-622 L-638,-614.801015 L49.490893,68 L52,65.490893 L-630.801015,-622 Z M-601.023018,-622 L-608,-615.020799 L79.6743393,68 L82,65.6765585 L-601.023018,-622 Z M-570.250335,-621 L-577,-614.250357 L109.898627,68 L112,65.8964167 L-570.250335,-621 Z M-540.434611,-621 L-547,-614.434611 L140.117523,68 L142,66.1175227 L-540.434611,-621 Z M-509.616132,-621 L-516,-614.620566 L148.155131,45 L150,43.1551308 L-509.616132,-621 Z M-479.834225,-621 L-486,-614.834247 L148.154039,15 L150,13.1540458 L-479.834225,-621 Z"
          mask="url(#pattern1mask)"
        />
      </g>
    </svg>
  );
}
